export const PAYMENT_TYPE = {
    ECOMM: "ECOMM",
    EBILL: "EBILL",
    SMART: "SMART",
    FLEX: "FLEX",
}